export default __webpack_public_path__ + "static/media/infoSuccess.040b8ce8.svg";